import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'
import { getHydratedDynamicConfig } from 'src/utils/hydrated-dynamic-config'
import { dynamicConfigClient } from '../client'

export function usePublicDynamicConfig<T = any>(
  path?: string | null,
  swrConfig?: SWRConfiguration,
) {
  const hydrated = path ? getHydratedDynamicConfig<T>(path) : undefined
  return useSWR<T | undefined>(
    path ? `dynamicConfig:${path}` : null,
    async () => {
      if (!path) return undefined
      const { data } = await dynamicConfigClient<T>({
        method: 'get',
        url: path,
      })
      return data
    },
    // Server-injected payload (when present) is returned synchronously on
    // first render so consumers (e.g. HomeBannerCarousel) skip the loading
    // state. SWR still revalidates in the background by default.
    hydrated !== undefined
      ? { fallbackData: hydrated, ...swrConfig }
      : swrConfig,
  )
}
